import React, { useEffect, useRef, useState } from 'react';
import { cn } from '@ais-ui/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from './Tooltip';

export const TruncatedText = ({
  text,
  className,
  maxWidth = '350px',
}: {
  text: string;
  className?: string;
  maxWidth?: string;
}) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const checkTruncation = () => {
      if (textRef.current) {
        const isOverflowing =
          textRef.current.scrollWidth > textRef.current.clientWidth;
        setShowTooltip(isOverflowing);
      }
    };

    checkTruncation();

    // Re-check on window resize
    window.addEventListener('resize', checkTruncation);

    // Re-check when element size changes (e.g., accordion opens)
    const resizeObserver = new ResizeObserver(checkTruncation);
    if (textRef.current) {
      resizeObserver.observe(textRef.current);
    }

    return () => {
      window.removeEventListener('resize', checkTruncation);
      resizeObserver.disconnect();
    };
  }, [text]);

  const textElement = (
    <span
      ref={textRef}
      className={cn('truncate block', className)}
      style={{ maxWidth }}
    >
      {text}
    </span>
  );

  if (showTooltip) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>{textElement}</TooltipTrigger>
        <TooltipContent>
          <p>{text}</p>
        </TooltipContent>
      </Tooltip>
    );
  }

  return textElement;
};
